module.exports = __webpack_public_path__ + "img/13-a-socially-just-energy.379dfcc1.jpg";